"use client";

import { Box, Icon, Radio, Text } from "@quintoandar-tokko/jopijs";
import { useState } from "react";
import { useSelector } from "react-redux";
import translations from "../../FichaInfo.trans.json";
import style from "../headerFI.module.scss";
import Trans from "@/components/shared/Trans";
import { UNIVEN_PUBLIC_HOST } from "@/services/constants";
import List from "./List";

export default function ExportToPdf() {
  const {
    edited_data,
    origin_data,
    showData,
    TOKKO_HOST,
    show_contact_pdf,
    from_univen,
    can_choose_pdf_language,
  } = useSelector((state) => state.FichaInfoSlice);
  const { has_edition } = edited_data;
  const { id } = origin_data;

  const [showDD, setShowDD] = useState(false);
  const map =
    showData === "origin_data"
      ? true
      : !has_edition
      ? true
      : edited_data.show_location;

  const versionFile = showData === "origin_data" ? false : true;
  const [lagunage, setLagunage] = useState({
    spanish: true,
    english: false,
  });

  const toggleLaguage = (option) => {
    setLagunage({
      spanish: false,
      english: false,
      [option]: true,
    });
  };
  const goToPdf = () => {
    let url = `${
      from_univen ? UNIVEN_PUBLIC_HOST : TOKKO_HOST
    }/properties/pdf_list_details/?ids=${id}&val=${
      map ? 5 : 4
    }&include_agent=${show_contact_pdf}&o=${versionFile}`;

    if (can_choose_pdf_language && lagunage.english) {
      url = url.concat("&in_english=true");
    }

    setShowDD(false);
    window.open(url, "_blank");
  };

  return (
    <Box __css={{ position: "relative" }}>
      <Box className={style.itemHeader} onClick={() => setShowDD(!showDD)}>
        <Icon
          className={style.exportIcon}
          icon="icon-exportar"
          fontSize="16px"
        />
        <Text className={style.exportText} variant="bodyBold.fontSize12">
          {Trans(translations, "ExportToPdf")}
        </Text>
      </Box>
      <List
        __css={{ borderRadius: "16px" }}
        open={showDD}
        seter={setShowDD}
        clickable
      >
        <Box className={style.contDDPdf}>
          <Box
            key="vertical"
            className={`${style.pdfOption} ${"vertical" && style.checked}`}
          >
            <Radio name="vertical" checked="vertical" readOnly />
            <Icon
              icon="icon-pdfvertical"
              style={{ height: "18px" }}
              fontSize="16px"
            />
            <Text fontSize="14px">Vertical</Text>
          </Box>
          {can_choose_pdf_language && (
            <Box className={style.contLanguage}>
              <Text variant="bodyBold.fontSize12">
                {Trans(translations, "Language")}
              </Text>
              <Box className={style.contItemsLanguage}>
                <Box
                  className={style.itemLanguage}
                  onClick={() => toggleLaguage("spanish")}
                >
                  <Radio readOnly name="spanish" checked={lagunage.spanish} />
                  <Text variant="body.fontSize12">
                    {Trans(translations, "Spanish")}
                  </Text>
                </Box>

                <Box
                  className={style.itemLanguage}
                  onClick={() => toggleLaguage("english")}
                >
                  <Radio readOnly name="english" checked={lagunage.english} />
                  <Text variant="body.fontSize12">
                    {Trans(translations, "English")}
                  </Text>
                </Box>
              </Box>
            </Box>
          )}
          <Box className={style.exportButton} onClick={goToPdf}>
            <Text variant="bodyBold.fontSize14">
              {Trans(translations, "ExportPdf")}
            </Text>
          </Box>
        </Box>
      </List>
    </Box>
  );
}
